export const endpoints = {
  createCallCredentials: (args) =>
    `/api/ai-mentor/orgs/${args.org}/users/${args.userId}/mentors/${args.mentor}/create-call-credentials/`,
};
